import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 32
}

/**
 * Stateless function representing a business trip icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <BusinessTripIcon width={12} />
 */
const BusinessTripIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M16.085 17.060c0.5-1.456 1.441-2.105
            3.052-2.105h1.045v-11.504l-8.365 4.184v-4.184l-8.367
            4.184v17.777h9.412v-7.32h2.873c0.127-0.379 0.244-0.728
            0.349-1.032zM10.771 22.275h-4.183v-4.183h4.183v4.183zM10.771
            14.955h-4.183v-4.183h4.183v4.183zM12.863
            10.772h4.183v4.183h-4.183v-4.183z`}
        />
        <path d="M16.928 21.232h0.001v-0.003z" />
        <path
            d={`M27.848
            21.041c-0.168-0.143-0.277-0.236-0.375-0.512-0.001-0.004-0.567-1.743-1.044-3.131-0.355-1.033-0.895-1.399-2.063-1.399h-5.229c-1.169
            0-1.708 0.365-2.063 1.399-0.476 1.388-1.043 3.128-1.044 3.131-0.099
            0.276-0.208 0.369-0.375 0.512-0.384 0.328-0.701 0.687-0.701 1.756v4.705c0
            0.575 0.471 1.045 1.045 1.045h1.045c0.576 0 1.047-0.471
            1.047-1.045v-1.045h7.32v1.045c0 0.575 0.471 1.045 1.045 1.045h1.047c0.575
            0 1.045-0.471 1.045-1.045v-4.705c0-1.069-0.319-1.428-0.701-1.756zM17.045
            24.367c-0.577 0-1.045-0.468-1.045-1.045 0-0.579 0.468-1.047 1.045-1.047
            0.579 0 1.047 0.468 1.047 1.047 0 0.577-0.468 1.045-1.047
            1.045zM23.843 25.412h-4.183c-0.288 0-0.523-0.236-0.523-0.523 0-0.288
            0.236-0.523 0.523-0.523h4.183c0.288 0 0.523 0.235 0.523 0.523 0.001
            0.287-0.235 0.523-0.523 0.523zM16.892 21.229c0 0 0.881-2.689 1.16-3.493
            0.185-0.536 0.273-0.689 1.077-0.689h5.245c0.803 0 0.892 0.155 1.077
            0.689 0.279 0.804 1.16 3.493 1.16 3.493h-9.72zM26.457 24.367c-0.577
            0-1.045-0.468-1.045-1.045 0-0.579 0.468-1.047 1.045-1.047 0.579 0
            1.047 0.468 1.047 1.047 0 0.577-0.468 1.045-1.047 1.045z`}
        />
    </SvgIcon>
)

BusinessTripIcon.defaultProps = defaultProps

export { BusinessTripIcon }
